/** @jsx h */
import { h } from 'preact'

import t from '../../../utils/translate'

const ThirdPartyVerification = ({ claimType }) =>
  <section class='ModalCard-section'>
    <h3 class='ModalCard-heading'>{t('proof_points.js.verified.how')}</h3>
    <p class='ModalCard-para u-marginTop8'>
      {t('proof_points.js.verified.3rd_party')} {claimType.toLowerCase()}.
    </p>
  </section>

export default ThirdPartyVerification
